
import { defineComponent } from "vue";
import {
  HomeTemplate,
  ContentTemplate,
  ContactTemplate,
} from "@/components/templates";
import { Footer } from "@/components/organisms";

export default defineComponent({
  name: "App",
  components: {
    Home: HomeTemplate,
    Content: ContentTemplate,
    Contact: ContactTemplate,
    Footer,
  },

  data() {
    return {
      current: "Home",
    };
  },
});
